import React, { useState, useEffect } from "react";
import "./header.css";
import logo from "../../assets/img/logo-with-stroke.png";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import { Link as ScrollLink } from "react-scroll";
import LogoColored from "../../assets/img/logo.png";
import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { FaSearch, FaChevronRight, FaUserAlt } from "react-icons/fa";
import { CgMenuGridR } from "react-icons/cg";
import { IoClose } from "react-icons/io5";
// import "./Navbar.css";
import $ from "jquery";
import Modal from "react-modal";

function Header() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const shouldRenderCarouselMenu = location.pathname.slice(-1);

  const [selectedSlide, setSelectedSlide] = useState();
  const [isNavExpanded, setIsNavExpanded] = useState(false);
  const [isMobileSubMenu, setIsMobileSubMenu] = useState(false);
  // const fetchedData = Axios({ path: '/carousel' });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isElligible, setIsElligible] = useState(false);
  const [isMindMap, setIsMindMap] = useState(false);
  // const [logo, setLogo] = useState(LogoOrg);
  let isLoggedIn;
  const handleMobileMenuSub = () => {
    setIsMobileSubMenu(true);
  };

  const handleLogin = () => {
    if (
      (username === "ValAdmin" && password === "ValAdmin") ||
      isLoggedIn === true
    ) {
      setIsElligible(true);
      setIsModalOpen(false);
      localStorage.setItem("isLoggedIn", true);
      isLoggedIn = localStorage.getItem("isLoggedIn");
    } else {
      localStorage.setItem("isLoggedIn", false);
      setIsElligible(false);
      isLoggedIn = localStorage.getItem("isLoggedIn");
    }
  };

  const handleModalOpen = (clicked) => {
    if (!isElligible) {
      setIsModalOpen(true);
      setIsMindMap(false);
    } else {
      setIsMindMap(true);
      setIsModalOpen(false);

      if (clicked === "logout") {
        setIsMindMap(false);
        setIsElligible(false);
        localStorage.setItem("isLoggedIn", false);
      }
    }

    if (clicked === "") {
      setIsMindMap(false);
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };
  const handleSubMindMenuOpen = (prev) => {
    setIsMindMap(!prev);
  };
  const openMenu = () => {
    $("#menu_img").toggle();
  };

  const handleSlideClick = (slideIndex) => {
    setSelectedSlide(slideIndex);
    $("#menu_img").toggle();
  };

  useEffect(() => {
    window.addEventListener("scroll", function () {
      const navbar = document.querySelector(".header");
      if (window.scrollY > 150) {
        navbar.classList.add("scrolled");
      } else {
        navbar.classList.remove("scrolled");
      }
    });
  }, []);

  const handleUsername = (input) => {};

  const handleSubMenuOpen = () => {
    console.log("hiiiii");
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1000);
    };
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleDropdown = () => {
    if (isMobile) {
      setIsDropdownOpen(!isDropdownOpen);
    }
  };

  const handleDropdownClick = () => {
    if (isMobile) {
      setIsDropdownOpen(!isDropdownOpen);
    }
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  const handleHover = () => {
    if (!isMobile) {
      setIsDropdownOpen(true);
    }
  };

  const handleLeave = () => {
    if (!isMobile) {
      setIsDropdownOpen(false);
    }
  };

  return (
    <header className="header">
      {/* <div className="navbar"> */}
      <div className="container_content">
        <div className="left_links">
          <div id="mobile_view" className="mobile_menu">
            {!isNavExpanded ? (
              <AiOutlineMenu
                onClick={() => setIsNavExpanded(true)}
                className="burger"
              />
            ) : (
              <AiOutlineClose
                onClick={() => setIsNavExpanded(false)}
                className="burger"
              />
            )}

            <div className={`nav ${isNavExpanded ? "nav-open" : ""}`}>
              <ul className="nav-list">
                <li className="nav-item">
                  <HashLink
                    to="/#Solution"
                    onClick={() => setIsNavExpanded(false)}
                  >
                    Solutions
                  </HashLink>
                </li>
                <li className="nav-item">
                  <HashLink
                    to="/#Retail"
                    onClick={() => setIsNavExpanded(false)}
                  >
                    Retail
                  </HashLink>
                </li>
                <li className="nav-item">
                  <HashLink
                    to="/#industry"
                    onClick={() => setIsNavExpanded(false)}
                  >
                    Services
                  </HashLink>
                </li>
                <li className="nav-item">
                  <HashLink
                    to="/#Telecom"
                    onClick={() => setIsNavExpanded(false)}
                  >
                    Telecom
                  </HashLink>
                </li>
                <li className="nav-item">
                  <HashLink
                    to="/#partners_scroll"
                    onClick={() => setIsNavExpanded(false)}
                  >
                    References
                  </HashLink>
                </li>
                <li className="nav-item">
                  <HashLink
                    to="/AboutUs"
                    onClick={() => setIsNavExpanded(false)}
                  >
                    About Us
                  </HashLink>
                </li>
              </ul>
            </div>
          </div>

          <div className="logo">
            <Link target="_blank" to="/">
              <img id="logo_img" src={logo} alt="" loading="lazy" />
            </Link>
          </div>
          <div className="links" id="pc_view">
            <HashLink
              className="link"
              to="/#Solution"
              spy={true}
              smooth={true}
              offset={-70}
              duration={50}
            >
              <h6>Solutions</h6>
            </HashLink>
            <HashLink
              className="link"
              to="/#Retail"
              spy={true}
              smooth={true}
              offset={-70}
              duration={50}
            >
              <h6>Retail</h6>
            </HashLink>
            <HashLink
              className="link"
              to="/#industry"
              spy={true}
              smooth={true}
              offset={-70}
              duration={50}
            >
              <h6>Services</h6>
            </HashLink>
            <HashLink
              className="link"
              to="/#Telecom"
              spy={true}
              smooth={true}
              offset={-70}
              duration={50}
            >
              <h6>Telecom</h6>
            </HashLink>
            <HashLink
              className="link"
              to="/#partners_scroll"
              spy={true}
              smooth={true}
              offset={-70}
              duration={50}
            >
              <h6>References</h6>
            </HashLink>
            {/* <HashLink
              className="link"
              to="/#media"
              spy={true}
              smooth={true}
              offset={-70}
              duration={50}
            >
              <h6>Media</h6>
            </HashLink> */}
            <HashLink
              className="link"
              to="/AboutUs"
              spy={true}
              smooth={true}
              offset={-70}
              duration={50}
            >
              <h6>About Us</h6>
            </HashLink>
          </div>
        </div>

        {/* <div className="side_links">
          <span>
              <FaSearch />
            </span>
          <div>
            <span
              onClick={handleModalOpen}
              className={
                shouldRenderCarouselMenu === "/" ? "" : "hide_carousel"
              }
            >
              <FaUserAlt />
            </span>
            {isMindMap && isElligible && (
              <ul className="subMenuMind">
                <Link
                  to="./MindMap"
                  onClick={() => handleModalOpen("closeSubMenu")}
                  target="_blank"
                  style={{ textDecoration: "none", color: "#777" }}
                >
                  <li>Mind Map</li>
                </Link>
                <li onClick={() => handleModalOpen("logout")}>Logout</li>
              </ul>
            )}
          </div>
          <span
            className={shouldRenderCarouselMenu === "/" ? "" : "hide_carousel"}
          >
            <CgMenuGridR
              onClick={openMenu}
              className={"carousel_items"}
              style={{
                fontSize: "26px",
              }}
            />
          </span>
        </div>
      </div>
      <div id="menu_img">
        <div className="row">
          {slides.map((slide, index) => (
            <div className="col-md-4 mb-3" key={index}>
              <div className="goTo" onClick={() => handleSlideClick(index)}>
                <img src={slide.image} alt="img" />
              </div>
            </div>
          ))}
        </div>*/}
      </div>

      {/* {(location.pathname === "/" || location.pathname === "/trial") && (
           <Carousel selectedSlide={selectedSlide} />
           )} */}

      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleModalOpen}
        contentLabel="Add Modal"
        className="ReactModal__Content_navbar"
      >
        <div className="">
          <div className="">
            <div className="">
              {/* <div>
                  <h5 className="pb-3 px-3">Add carousel</h5>
                </div> */}
              <div className="row px-4 d-flex flex-column align-items-center justify-content-center">
                <span
                  onClick={handleModalClose}
                  className="text-end clodeModal"
                >
                  <IoClose
                    style={{
                      width: "25",
                      height: "25",
                      cursor: "pointer",
                      color: "#000",
                    }}
                  />
                </span>
                <img
                  src={LogoColored}
                  className="w-75 mb-5"
                  loading="lazy"
                  alt=""
                />
                <div className="col-md-12">
                  <input
                    type="text"
                    placeholder="Username"
                    value={username}
                    onChange={handleUsernameChange}
                    className="form-control"
                  />
                </div>
                <div className="col-md-12 mt-4">
                  <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={handlePasswordChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="px-4 d-flex justify-content-center gap-3 mt-5">
                <button className="btn btn-danger w-75" onClick={handleLogin}>
                  Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* </div> */}
    </header>
  );
}

export default Header;
